import { defineCustomElement } from 'vue'
import '@google/model-viewer'

import Viewer2 from './components/Viewer2.vue'

const Viewer2CustomElement = defineCustomElement(Viewer2)

customElements.define('monocle-viewer2', Viewer2CustomElement)

// Export the model-viewer from @google/model-viewer so consumers don't need to load it separately
// This prevents the "CustomElementRegistry: the name 'model-viewer' has already been used" error
